import { Entry } from '../Entry'

export function Entry20250709() {
  return (
    <Entry title="2025 Jul 9 - v3.10.15">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/17898/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
